import { render, staticRenderFns } from "./Nametag.vue?vue&type=template&id=56cba928&"
import script from "./Nametag.vue?vue&type=script&lang=js&"
export * from "./Nametag.vue?vue&type=script&lang=js&"
import style0 from "./Nametag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports